import { render, staticRenderFns } from "./EditResellerServiceComponent.vue?vue&type=template&id=3b6c4f8d&"
import script from "./EditResellerServiceComponent.vue?vue&type=script&lang=js&"
export * from "./EditResellerServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports